// Relic icons (32×32, id relic_<id>), shown on the Reliquary shelf. 1-px ink outline, light from
// top-left. Relics are old, precious and a little macabre: brass, velvet, bone, tarnish.
// Key: '.' transparent, 'o' ink outline, other chars per sprite.
import { sprite, type SpriteDef } from './types';

export const relicGlassEye = sprite(
  'relic_glasseye_r',
  {
    o: 'ink',
    b: 'brick',
    m: 'maroon',
    a: 'aubergine',
    c: 'cerise',
    C: 'crimson',
    w: 'white',
    p: 'paper',
    s: 'steel',
    r: 'coral',
    S: 'sky',
    B: 'blue',
    l: 'cobalt',
    n: 'navy',
    L: 'lilacGrey',
    R: 'brass',
    e: 'lemon',
    O: 'copper',
    g: 'gold',
    A: 'amber',
  },
  [
    '................................',
    '................................',
    '......oooooooooooooooooooo......',
    '.....obbbbbbbbbbbbbbbbbbbbo.....',
    '.....obmmmmmmmmmmmmmmmmmmao.....',
    '.....obmccccccccccccccccmao.....',
    '....obmmccccccccccccccccmmbo....',
    '....obmCCCaCCCCCaCCCCCaCmmao....',
    '....obmCCCCCCCooooCCCCCCCmao....',
    '....obmCCCCCoowwwpooCCCCCmao....',
    '....obmCCCCowwwwwwppoCCCCmao....',
    '...obmmCcCowwwwwwwppsocCCmmbo...',
    '...obmCCCowwwwwwwwppsroaCmmao...',
    '...obaaaaowwwwwSSSBlssroaaaao...',
    '...ooooooowwwwSSwSBBnsooooooo...',
    '..oaaaaaopwwwwSSooolnLLoaaaaao..',
    '..oCCCCCCopwwwBBooolnLoCCCCCCo..',
    '..oCCCCaaoprrplBBoonnLoaaCCCCo..',
    '..oCCCaaaosprppllnnnLLoaaaCCCo..',
    '..oCCCCaaaosssssssLLLoaaaCCCCo..',
    '..oooooooooooooooooooooooooooo..',
    '..oRRRRRRRRRRoeeeeoRRRRRRRRRRo..',
    '..obOOOOOOOOOoeggAoOOOOOOOOOao..',
    '..obmmmmmmmmmoeooAommmmmmmmmao..',
    '..obmmmmmmmmmoeAAAommmmmmmmmao..',
    '..obmmmmmmmmmmoooommmmmmmmmmao..',
    '..obmmmmmmmmmmmmmmmmmmmmmmmmao..',
    '..obaaaaaaaaaaaaaaaaaaaaaaaaao..',
    '...oooooooooooooooooooooooooo...',
    '................................',
    '................................',
    '................................',
  ],
);

export const relicMolar = sprite(
  'relic_molar',
  {
    o: 'ink',
    b: 'bronze',
    B: 'brick',
    w: 'white',
    m: 'mauveGrey',
    c: 'cream',
    s: 'sand',
    l: 'lemon',
    g: 'gold',
    a: 'amber',
  },
  [
    '................................',
    '................................',
    '..............ooo...............',
    '.............obBbo..............',
    '............oboooBo.............',
    '...........oBo...obo............',
    '............oBooobo.............',
    '.........ooooobBboooooo.........',
    '........owwwwmoBoowcccmo........',
    '.......owwwwwwmoowwccccmo.......',
    '......owwwwwwwwwwwwccccsmo......',
    '.....owwwwwwwwwsswcccccssmo.....',
    '.....owwwwwwwwwwsccccccssmo.....',
    '.....owwwwwwwwwwwcllggcssmo.....',
    '.....owwwwwwwwwwccggaasssmo.....',
    '.....owwwwwwwwwccccccssssmo.....',
    '.....owwwwwwwccccccccssssmo.....',
    '.....owwwwwwccccccccsssssmo.....',
    '.....omccccccccmmccsssssmmo.....',
    '......omccccccmoocsssssmoo......',
    '.......ocsccccmoossssssmo.......',
    '.......occscccmoossssssmo.......',
    '.......omcscccmoomssssmo........',
    '........ocsssmo..ossssmo........',
    '........ossssmo..ossssmo........',
    '........omsssmo..osssmo.........',
    '.........osssmo..omssmo.........',
    '.........ommmo....ommmo.........',
    '..........ooo......ooo..........',
    '................................',
    '................................',
    '................................',
  ],
);

export const relicBrassKnuckles = sprite(
  'relic_brassknuckles',
  { o: 'ink', b: 'blood', c: 'cream', B: 'brass', r: 'brick', C: 'copper', m: 'maroon', n: 'bronze' },
  [
    '................................',
    '................................',
    '................................',
    '................................',
    '................................',
    '............oo..................',
    '......oooooobbo.oooooooooo......',
    '.....occBrCbmcroCccBrCcccro.....',
    '....ocCoCnCcConnCConnCCConro....',
    '....ocCooBCCoooBCoooBcCooBro....',
    '....ocoooBCCoooBCoooBcCoooro....',
    '....oBnooBCnooBCBnooBBnooBro....',
    '....oBnBBCCnBBBCnnBBCBnBBCro....',
    '...oorrrrrrrrrrrrrrrrCCrrrroo...',
    '...oBooooooooooooooooooooooro...',
    '...orBBBro............onCCCro...',
    '....oBBBroo..........ooCCCro....',
    '....orBBBBroo......oonCCCCro....',
    '.....ornnnnnroooooonnCCCCro.....',
    '......ornnnnnnnnnnnCCCCCro......',
    '.......ornnnnnnnnCCCCCCro.......',
    '........orrBBBBBBBBCCrro........',
    '.........oorrrrrrrrrroo.........',
    '...........oooooooooo...........',
    '................................',
    '................................',
    '................................',
    '................................',
    '................................',
    '................................',
    '................................',
    '................................',
  ],
);

export const relicOiledGears = sprite(
  'relic_oiledgears',
  {
    o: 'ink',
    l: 'lemon',
    b: 'brass',
    w: 'white',
    B: 'bronze',
    r: 'brick',
    g: 'gold',
    c: 'copper',
    a: 'amber',
    p: 'paper',
    s: 'steel',
    d: 'dusk',
    L: 'lilacGrey',
  },
  [
    '................................',
    '................................',
    '............oo.......l..........',
    '........oo.obbo.....lwl.........',
    '.......obboobBbo.....l...o......',
    '......obBBbbBBrooooo....olo.....',
    '.......obBBBBBBbblbbo..ogggo....',
    '....ooobBrrrorrcBBlro.olglgco...',
    '...obbbBrrcooocccBro..ogwgggo...',
    '...obBBrrcccccccccBbooogwgaco...',
    '....obBrooccBccoocBBbboaaacco...',
    '....obrcocBBBBBcoccBBrooccco....',
    '...oobrcccBoooBccccBrro.ooo.....',
    '..obbBrcccBoooBccccroo..........',
    '..obBBrcocBBBBBcoccro...........',
    '..obrBBcooccBccoocBroooo........',
    '...oobBcccccccccccBBboppo.......',
    '.....obBcccooocccBrrrosdo.o.....',
    '....obBBBcccocccBrooossspopo....',
    '....obrrrrBBBBBBrossssssspspo...',
    '.....ooooobBBrrBBbossLLLssdo....',
    '.........obBroobropsLooLssdo....',
    '..........obro.oopssLooLssdo....',
    '...........oo..opdssLsoLssspo...',
    '................oopssLLssdddo...',
    '..................opssssdooo....',
    '.................opsdddsdo......',
    '..................opooopdo......',
    '...................o...oo.......',
    '................................',
    '................................',
    '................................',
  ],
);

export const relicBoneDice = sprite(
  'relic_bonedice',
  { o: 'ink', w: 'white', m: 'maroon', c: 'cream', M: 'mauveGrey', s: 'sand', u: 'mulberry' },
  [
    '................................',
    '................................',
    '..........oo....................',
    '........oowwoo..................',
    '......oowwwwwwoo................',
    '....oowwwwwwwwwwoo..............',
    '...owwwwwwmmwwwwwwo.............',
    '..ocwwwwwwmmwwwwwwMo............',
    '..occcwwwwwwwwwwssMo............',
    '..occcccwwwwwwssssMo............',
    '..occmccccwwssssssMo............',
    '..occmcccccsuussssMoo...........',
    '..occscccccsuusssoowwoo.........',
    '..occcsccccsssuoowwwwwwoo.......',
    '..occccccccssoowwwwmmwwwwoo.....',
    '..osccccmccsowwwmwwwwwwmwwwo....',
    '...ossccmccocwwwmwwwwwwmwwwMo...',
    '....oosscccocccwwwwmmwwwwssMo...',
    '......oosscocccccwwwwwwssusMo...',
    '........oosoccmccccwwsussusMo...',
    '..........ooccmcccccssussusMo...',
    '...........occccccccsssssusMo...',
    '...........occccccccssussssMo...',
    '...........osccccmccssussusMo...',
    '............ossccmccssussuMo....',
    '.............oosscccssuMMoo.....',
    '...............oosscsMMoo.......',
    '.................oosMoo.........',
    '...................oo...........',
    '................................',
    '................................',
    '................................',
  ],
);

export const relicWeightedCoin = sprite(
  'relic_weightedcoin',
  {
    o: 'ink',
    b: 'brass',
    B: 'bronze',
    c: 'copper',
    C: 'cream',
    r: 'brick',
    s: 'steel',
    d: 'dusk',
    l: 'lilacGrey',
  },
  [
    '................................',
    '................................',
    '................................',
    '............oooooooo............',
    '.........ooobbbbbbbbooo.........',
    '........obbbbbbbbbbbbbBo........',
    '......oobbbccccccccccBBBoo......',
    '.....obbbccBBBBCCCBBBBBBBBo.....',
    '.....obbccBBBBCBBBcBBBBBBco.....',
    '....obbcBBBBBBCBBBcBBBBBbcco....',
    '....obbcBBBBBBBCccBBBBBBbcco....',
    '....obbcBBBBBBCbbbcBBBBBbcco....',
    '...ocbbcBBBBBCbbbbbcBBBBbccro...',
    '...ocbbcBBBBCbbbbbbbcBBBbccro...',
    '...osbbcBBBBcccccccccBBBbccdo...',
    '...ocBbbcBBBBBBBBBBBBBbldcrro...',
    '...ocBbBBBBBBBBBBBBBdlldlcrro...',
    '....oscBBBBBbbbbbbbdlsdllrdo....',
    '....ossBcBBcccccccccsdlldddo....',
    '....oBsscBccccccccccdlldldro....',
    '.....ocsssccrcrcrcrclldllro.....',
    '.....ocBssslllllllllldddrro.....',
    '......oocBslllllllllldrroo......',
    '........oBccrcrcrcrcrrro........',
    '.........ooorcrcrcrcooo.........',
    '............oooooooo............',
    '................................',
    '................................',
    '................................',
    '................................',
    '................................',
    '................................',
  ],
);

export const relicPocketSun = sprite(
  'relic_pocketsun',
  {
    o: 'ink',
    b: 'brass',
    B: 'bronze',
    c: 'copper',
    p: 'paper',
    s: 'steel',
    r: 'rust',
    i: 'indigo',
    n: 'navy',
    O: 'orange',
    S: 'sky',
    g: 'gold',
    P: 'purple',
    w: 'white',
    l: 'lemon',
    a: 'amber',
  },
  [
    '................................',
    '................................',
    '............oooooooo............',
    '...........obbbbbbbbo...........',
    '..........obBBBBBcBBbo..........',
    '..........obBBcBBBBBco..........',
    '..........obBcBBBBcBco..........',
    '..........obccccccccco..........',
    '.........opoooooooooopo.........',
    '.........osssssssssssso.........',
    '..........oooooooooooo..........',
    '.........orrrrrrrrrrrro.........',
    '..........oooooooooooo..........',
    '..........oinnnOnnnnio..........',
    '.........oiSnnnOnnnnnio.........',
    '........oiSnnnngPnnnnnSo........',
    '.......oiSnOgPPPgPPgOnnSo.......',
    '......oiwnnngPwwwlPgnnnSio......',
    '......oiwnnPPwwwwlgPPnnnio......',
    '......oiwnnPwwwwllgOPnnnio......',
    '.....oiwnOgglwwllgaOggOOnio.....',
    '......oiwnnPglllggaOPnnnio......',
    '......oiwnnPPgggaaOPPnnnio......',
    '......oiSnnngPaaOOPgnnnnio......',
    '.......oiSnOgPPPPPPgOnnio.......',
    '........oiSnnnnPgnnnnnio........',
    '.........oinnnnngnnnnio.........',
    '..........oiiiiiOiiiio..........',
    '...........oooooooooo...........',
    '................................',
    '................................',
    '................................',
  ],
);

export const relicRatCrown = sprite(
  'relic_ratcrown',
  {
    o: 'ink',
    w: 'white',
    p: 'paper',
    s: 'steel',
    b: 'brass',
    B: 'bronze',
    O: 'olive',
    c: 'cerise',
    C: 'cream',
    r: 'crimson',
    W: 'wine',
    a: 'aubergine',
    m: 'moss',
    S: 'salmonPink',
    R: 'red',
    l: 'blood',
    v: 'clover',
    f: 'forest',
    d: 'dustyPink',
    e: 'copper',
    E: 'rose',
  },
  [
    '................................',
    '................................',
    '................................',
    '...............oo...............',
    '..............owwo..............',
    '......ooo....opppso....ooo......',
    '.....obbBo....osso....obbBo.....',
    '.....obbBo...oooooo...obbBo.....',
    '.....oBOOoooocoCOorooooBOOo.....',
    '......ooooccccoCOorrWWoooo......',
    '.....oCbCocccoCbbCoWWWoCBCo.....',
    '.....oCbOocccoCbbOoWWWoCBOOo....',
    '.....oCbOocraoCbbOoWWaoCBOmo....',
    '....oCbbbCoroCbbbbCoaoCBBOCo....',
    '....oCbbbOoroCbbbbOoaoCBOOOo....',
    '...oCbbbbbCoCbbbbbBCoCBBOOOCo...',
    '...obbbbbbOoCbbbbBBOoCBOOOBBo...',
    '...oCbbbbbOoCbbBBBBOoCBBBBOOo...',
    '....oCbbbbbbbbbbbbbbBBOOooOo....',
    '....oCbbbbbBBBBBBBBOOOmoSSoo....',
    '....oCBBOORlBBBooBOOvfOoSdSo....',
    '....oeBBOmllBBBooOOOffOOoSdSo...',
    '....oeOOOOBBBOOOOOOOOOOOOoSdSo..',
    '.....oooooeOOOOOOOOOOOoooooSEo..',
    '..........oooooooooooo....oSEo..',
    '...................oSoooooSdEo..',
    '....................oSSSSSdEo...',
    '....................oSEEEEEo....',
    '.....................oooooo.....',
    '................................',
    '................................',
    '................................',
  ],
);

export const relicChalice = sprite(
  'relic_chalice_r',
  {
    o: 'ink',
    l: 'lemon',
    w: 'white',
    g: 'gold',
    c: 'coral',
    a: 'amber',
    r: 'red',
    b: 'blood',
    p: 'paper',
    s: 'steel',
    L: 'lilacGrey',
    d: 'dusk',
  },
  [
    '................................',
    '................................',
    '.................o..l...........',
    '................ololwl..........',
    '.........l..o..olglol...........',
    '........lwlocooolgaoo...........',
    '.........loccroolgaoooo.........',
    '.........oorrbogoloolllo........',
    '........oggoboaaaoolggglo.......',
    '.......ooollogllgglolaaoo.......',
    '......olllooooooooooooooao......',
    '.....olaaalopppppsssLLLdo.......',
    '......ooooowwpppppppppddo.......',
    '.......odlllggggggggaaddo.......',
    '....o...opppppssssLLLddo........',
    '...olo..odpppsssssLLLddo........',
    '...ollo..opssssssLLLddo.........',
    '..olgao..odsssssLLLdddo.........',
    '...olao...oddsLLLLdddo..........',
    '...olo.....ooddLLddoo...........',
    '....o........ooLdoo.............',
    '.............oddddo.............',
    '.............oddddo.............',
    '..............oddo..............',
    '............oooddooo...ooo......',
    '...........oddddddddo.olllo.....',
    '..........oddddddddddolaaalo....',
    '.........oddddddddddddooooo.....',
    '..........oddddddddddo..........',
    '...........oooooooooo...........',
    '................................',
    '................................',
  ],
);

export const relicReceiptRoll = sprite(
  'relic_receiptroll',
  { o: 'ink', w: 'white', s: 'steel', p: 'paper', l: 'lilacGrey', d: 'dusk', r: 'red' },
  [
    '................................',
    '................................',
    '.........o......................',
    '.......oowooooooo...............',
    '......owwwwwowwwwo..............',
    '.....owwwwwspowwwwo.............',
    '.....owwswwpsoppppo.............',
    '....owsswsspppopppo.............',
    '....owwwwwppppopppo.............',
    '....owwwlolsssoppppo............',
    '....owwwlolpssoppppo............',
    '....owwwlolpssoppppo............',
    '....owwpsppsspopppo.............',
    '....owspppppppopppo.............',
    '.....opspppssosssso.............',
    '.....oppssppposssso.............',
    '......opppsposssso..............',
    '.......oopoosssssoooooo.........',
    '.........ooooooooowwwppoo.......',
    '.........ossplppwwwllllppo......',
    '.........osspplllllwwpplpsoo....',
    '.........ossplppwwwllplppdsso...',
    '.........osspplllllwwppllsdso...',
    '..........osppppwwwwwprppdsdso..',
    '...........oopppwwwwwpprrssso...',
    '.............oooooooooooprsdso..',
    '........................oosso...',
    '..........................osso..',
    '...........................oo...',
    '................................',
    '................................',
    '................................',
  ],
);

export const relicLedger = sprite(
  'relic_ledgernames',
  {
    o: 'ink',
    m: 'maroon',
    a: 'aubergine',
    c: 'copper',
    b: 'brass',
    B: 'brick',
    C: 'cream',
    s: 'sand',
    r: 'bronze',
    d: 'dusk',
    w: 'wine',
    R: 'red',
    l: 'blood',
  },
  [
    '................................',
    '................................',
    '.....ooooooooooooooooo..........',
    '....omaccccccccccbbbbbo.........',
    '...oBmaBBBBBBBBBBBbbCCosCs......',
    '...oBmaBBBBBBBBBBBBbbCosCso.....',
    '...occcBBrrrrrrrrrrBbbosCsao....',
    '...oBmaBBrCCCCCCCCrBBbosCsao....',
    '...oBmaBBrCddCdddCrBBmosCsao....',
    '...oBmaBBrCCCCCCCCrBBmosCsao....',
    '...oBmaBBrCddddCCCrBBmosCsao....',
    '...oBmaBBrCCCCCCCCrBBmosCsao....',
    '...occcBBrrrrrrrrrrBBmosCsao....',
    '...oBmaBBBBBBBBBBCbbBmosCsao....',
    '...oBmaBBBBBBBBBwbobwwwoCsao....',
    '...oBmaBBBBBBBBBmbobmmmoCsao....',
    '...oBmaBBBBBBBBBmbobmmmoCsao....',
    '...oBmaBBBBBBBBBBbbcBmosCsao....',
    '...occcBBBBBBBBBBBBBBrosCsao....',
    '...oBmaBBBBBBBBBBBBBrrosCsao....',
    '...oBmaBBBBBBBBBBBBrrrosCsao....',
    '...oBmaBBBBBBBBBBBrrrrosCsao....',
    '....omammmmmmmmmmrrrrrosCsao....',
    '.....ooooooooooooooooossCsao....',
    '.....CCCCCCCoRloCCCCCCCsCsao....',
    '.....sssssssoRlossssssssCsao....',
    '......oaaaaaoRloaaaaaaaaaaao....',
    '.......ooooooRloooooooooooo.....',
    '.............olo................',
    '..............o.................',
    '................................',
    '................................',
  ],
);

export const relicEternalFruit = sprite(
  'relic_eternalfruit',
  {
    o: 'ink',
    l: 'leaf',
    b: 'brick',
    m: 'mud',
    c: 'clover',
    f: 'forest',
    L: 'lemon',
    w: 'white',
    g: 'gold',
    a: 'amber',
    C: 'copper',
  },
  [
    '................................',
    '................................',
    '................................',
    '................................',
    '....................ooooo.......',
    '................oo.olllllo......',
    '...............obmolccffo.......',
    '......L........obolcffffo.......',
    '.....LwL.......oolffffoo........',
    '......L........obooloo..........',
    '.........oooooobboooooo.........',
    '.......ooLLLLLLooLgggaaoo.......',
    '......oLLLLLLLLaaagggLaCCoL.....',
    '......oLLLLLLLLLLggggaLCCow.....',
    '.....oLLLLwwLLLLggggaaaCLwwwL...',
    '.....oLLLLwLLLLgggggaaaCCCw.....',
    '....oLLLLwLLLLgggggaaaCCCCLo....',
    '....oLLLLLLLggggggaaaaCCCCCo....',
    '....ogLLLLgggggggaaaaCCCCCCo....',
    '....ogggggggggggaaaaCCCCCCCo....',
    '....oggggggggggaaaaaCCCCCCCo....',
    '.....ogggggggaaaaaCCCCCCCCo.....',
    '.....oaaaaaaaaaaaCCCCCCCCCo.....',
    '......oaaaaaaaaCCCCCCCCCCo......',
    '......oaaaaaaCCCCCCCCCCCCo......',
    '.......ooCCCCCCCCCCCCCCoo.L.....',
    '.........ooCCCCCCCCCCoo..LwL....',
    '...........ooCCCCCCoo.....L.....',
    '.............oooooo.............',
    '................................',
    '................................',
    '................................',
  ],
);

export const relicBentSpoke = sprite(
  'relic_wheelspoke',
  {
    o: 'ink',
    c: 'coral',
    r: 'red',
    C: 'cream',
    b: 'blood',
    B: 'brass',
    m: 'maroon',
    n: 'bronze',
    p: 'paper',
    e: 'copper',
    s: 'steel',
    R: 'rust',
    i: 'brick',
    d: 'dusk',
    l: 'lilacGrey',
  },
  [
    '................................',
    '................................',
    '................................',
    '................................',
    '........................oooo....',
    '.....................oooccrro...',
    '...................ooCCorrbbo...',
    '..................oCCBBBobmmo...',
    '................oooCBBnnnooo....',
    '..............ooppoBnnneoo......',
    '.............oppssonneeoo.......',
    '...........oopssRidooooro.......',
    '..........opssllddoo..obo.......',
    '..........osslddoo.....o........',
    '.........oplldoo................',
    '........opsldo..................',
    '........opsRdo..................',
    '.......opsldo...................',
    '.......opsldo...................',
    '......opslio....................',
    '......opsRdo....................',
    '.....opsldo.....................',
    '.....opsldo.....................',
    '....opsspooo....................',
    '....opllppplo...................',
    '.....oldppslo...................',
    '......oossldo...................',
    '........oddo....................',
    '.........oo.....................',
    '................................',
    '................................',
    '................................',
  ],
);

export const relicPinballHeart = sprite(
  'relic_pinballheart',
  {
    o: 'ink',
    l: 'lilacGrey',
    d: 'dusk',
    L: 'lemon',
    w: 'white',
    s: 'steel',
    p: 'paper',
    n: 'navy',
    f: 'flesh',
    c: 'cerise',
  },
  [
    '................................',
    '................................',
    '................................',
    '................................',
    '................................',
    '.........oooo......oooo.........',
    '.......oollldoo..oollldoo.......',
    '......olllLllldoollllllldo......',
    '.....ollllwlllllllllllllldo.....',
    '.....ollLwwwLssssssssllwldo.....',
    '....ollssswssssssssssssswldo....',
    '....osssssLssssssssssssswslo....',
    '....ossssssssssssssssssssslo....',
    '....olsssppppppppppppppssslo....',
    '.....oppppppppppppppppppplo.....',
    '.....olppppwwwwwwwwwwpppplo.....',
    '......olwwwwwwwwwwwwwwwwlo......',
    '.......olnnnnnnnnnnnnnnlo.......',
    '........oddddddddddddddo........',
    '.........oddddddddddddo.........',
    '.........odddlllllldfdo.........',
    '..........odlllllllffo..........',
    '...........olllllllco...........',
    '...........odlllllldo...........',
    '............olsssslo............',
    '.............olsslo.............',
    '..............oslo..............',
    '..............ollo..............',
    '...............oo...............',
    '................................',
    '................................',
    '................................',
  ],
);

export const relicCrackedHalo = sprite(
  'relic_crackedhalo',
  { o: 'ink', l: 'lemon', w: 'white', g: 'gold', a: 'amber', c: 'copper' },
  [
    '................................',
    '................................',
    '..............l..........l......',
    '.....l.......lwl.........w......',
    '....lwl.......l........lwwwl....',
    '.....l....l.........l....w......',
    '..........oooooooooooo...l......',
    '.......ooowwwwwllllllgooo.......',
    '.....oowwwwwwwllllllgggggoo.....',
    '....owwwwwwooooooooooggggaao....',
    '...owwwwooo..........oooaaaao...',
    '...owwwo................oaaao...',
    '..owwwwo................oaaaao..',
    '...owwwwooo..........oooaaaao...',
    '...owwlllllooooooooooaaaaaaao...',
    '...oallllllggggggaaaaoooooaco...',
    '....oaalllggggggaaacooaaaaoo....',
    '.....oaaaagggggaaacooaaaaco.....',
    '......ooaaaaaccccccoaacccco.....',
    '........oooaacccccccocccoo......',
    '...........ooooooooooooo........',
    '................................',
    '................................',
    '.....................o...a......',
    '....................ogo.........',
    '.....................o..........',
    '.......................o........',
    '..................a...ogo.......',
    '.......................o........',
    '................................',
    '................................',
    '................................',
  ],
);

export const relicSecondStomach = sprite(
  'relic_secondstomach',
  {
    o: 'ink',
    p: 'paper',
    d: 'dusk',
    s: 'steel',
    l: 'lilacGrey',
    w: 'white',
    n: 'night',
    c: 'coral',
    k: 'khaki',
    S: 'sage',
    C: 'celadon',
    i: 'ice',
    a: 'apricot',
    m: 'salmonPink',
    f: 'flesh',
    e: 'cerise',
    r: 'cream',
    A: 'sand',
    b: 'blood',
  },
  [
    '................................',
    '................................',
    '................................',
    '.......oooooooooooooooooo.......',
    '......opppppppppppppppppdo......',
    '.....oslwlslslslslslslslsdo.....',
    '.....oslwlslslslslslslslsdo.....',
    '.....oslslslslslslslslslsdo.....',
    '.....oddddddddddddddddddddo.....',
    '.....oooooooooooooooooooooo.....',
    '.....odnnoccconnnnnnnnnnndo.....',
    '.....okkkocccokkkkkkkkkkkSo.....',
    '.....okCCocccooooCCCCCCCCSo.....',
    '.....okCCCoccccccoCCCiCiCSo.....',
    '.....okCwCoccccacmoooCCCCSo.....',
    '.....okCwCocccacmmmmmoiCCSo.....',
    '.....okCwCoccacmmmmmffoCCSo.....',
    '.....okCwooccmmmmeeffffoCSo.....',
    '.....okowmoommmmmmfeeeeoCSo.....',
    '.....okommmommmmmffffeeoCSo.....',
    '.....okommmommmfeeffeeeoCSo.....',
    '.....okCofffffffffeeeeeoCSo.....',
    '.....okCwfffffffeeeeeeoCCSo.....',
    '.....okCwoeeeeeoeoooooooCSo.....',
    '.....okCCCoooooCowwwwwwwoSo.....',
    '.....okCCCCCCCCCowddrdrAoSo.....',
    '.....oSCCCCCCCCCowbbbbrAoSo.....',
    '......oSCCCCCCCCowAAAAAAoo......',
    '.......oSSSSSSSSSoooooooo.......',
    '........oooooooooooooooo........',
    '................................',
    '................................',
  ],
);

export const relicSilverFork = sprite(
  'relic_silverfork',
  {
    o: 'ink',
    w: 'white',
    l: 'lilacGrey',
    p: 'paper',
    s: 'steel',
    d: 'dusk',
    f: 'flesh',
    P: 'pinkLilac',
    c: 'cerise',
    W: 'wine',
  },
  [
    '................................',
    '................................',
    '.........oo..oo..oo..oo.........',
    '........owwoowwoowwoowwo........',
    '........owloowloowloowlo........',
    '........owloowloowloowlo........',
    '........owloowloowloowlo........',
    '........owloowloowloowlo........',
    '........owloowloowloowlo........',
    '........owloowloowloowlo........',
    '........owloowloowloowlo........',
    '........owloowloowloowlo........',
    '........owpwwppwwsswwslo........',
    '.........owppppsssssslo.........',
    '..........owlppssssllo..........',
    '...........oowssssloo...........',
    '.............owsslo.............',
    '..............owlo..............',
    '..............owlo..............',
    '.............owwwdo.............',
    '..............owlo..............',
    '..............owlo..............',
    '.............owsswo.............',
    '............owllllwo............',
    '...........owllffwwwo...........',
    '...........owlfPcWwlo...........',
    '...........owllcWwwlo...........',
    '...........owlwwwwllo...........',
    '............oowllloo............',
    '..............oooo..............',
    '................................',
    '................................',
  ],
);

export const relicCrowsNest = sprite(
  'relic_crowsnest',
  {
    o: 'ink',
    i: 'indigo',
    p: 'purple',
    n: 'navy',
    l: 'lilacGrey',
    N: 'night',
    L: 'lemon',
    w: 'white',
    b: 'brick',
    m: 'mud',
    g: 'gold',
    a: 'amber',
    c: 'copper',
    s: 'sand',
    B: 'bronze',
  },
  [
    '................................',
    '................................',
    '................................',
    '....oooo........................',
    '...oipnno.......................',
    '...oiplnno......................',
    '...oiiplnno.....................',
    '....oiilnnno....................',
    '....oiiplnnno...................',
    '....oiiiplnno...................',
    '.....oiNilnnno..................',
    '......oiNplnno..................',
    '......oiiiplnno.....L...........',
    '.......ooooooooooooowooo........',
    '......oobbbbbbooooLwwwLboo......',
    '....oobbbbbbboLLLLLLwbbbbboo....',
    '...obbbbbmmmoLgaggagLombbbbbo...',
    '...obbbmmmmooLgaaaagcommmbbbo...',
    '...oooooooooooooooooooooooooo...',
    '..ossssssssssssssssBBBBBBBBBBo..',
    '..omcbBBbbbBBbbscsssbbbbbbBBmo..',
    '...oBBbccBBbbccbssbbcBbbBBbmo...',
    '...ombbbBBBBcbbbbbbbbBbbbmmmo...',
    '....obBbbbBbbbbbbbbbbbbbbbmo....',
    '.....ombBBBBBbbbbBBbbBbbbbo.....',
    '......oommbbBBbbbbmmmbmmoo......',
    '........oobmmmmmmmmmmmoooo......',
    '..........oooooooooooo.ommoo....',
    '........................oommo...',
    '..........................oo....',
    '................................',
    '................................',
  ],
);

export const relicDeed = sprite(
  'relic_deed',
  {
    o: 'ink',
    c: 'cream',
    w: 'white',
    s: 'sand',
    m: 'mauveGrey',
    C: 'coral',
    r: 'red',
    b: 'blood',
    M: 'maroon',
  },
  [
    '................................',
    '................................',
    '................................',
    '................................',
    '.....................oo.........',
    '...................oocco........',
    '..................owwcsco.......',
    '................oowwwcscso......',
    '...............owwwwwcsmcco.....',
    '.............oowwwwcccccmso.....',
    '............oCwwwwccccsscsco....',
    '..........ooCCwwcccccssscsco....',
    '.........owwCCCccccssssmmcco....',
    '.......oowwwwCrrcsssssmmmmo.....',
    '.....oowwwwccrrrssssmmmmoo......',
    '....owwwwwccccrrrssmmmoo........',
    '...owwwwcccccssroooooo..........',
    '...owwwccccssssoCCCrro..........',
    '...owcccccssssoCCCCrro..........',
    '....occcsssssmoCCCbbbMo.........',
    '....occssssmmmorCMMMbMo.........',
    '.....ossssmmmoorrbbbMo..........',
    '......osmmmmo..obbMMo...........',
    '.......ommoo...oooMMoo..........',
    '........oo....orrooobo..........',
    '..............orro.obo..........',
    '.............orro..obbo.........',
    '..............oo....oo..........',
    '................................',
    '................................',
    '................................',
    '................................',
  ],
);

export const relicHourglass = sprite(
  'relic_hourglass_r',
  {
    o: 'ink',
    l: 'lemon',
    g: 'gold',
    b: 'blood',
    a: 'amber',
    c: 'copper',
    i: 'indigo',
    s: 'sky',
    w: 'white',
    n: 'navy',
    r: 'red',
    C: 'coral',
  },
  [
    '................................',
    '................................',
    '.........oooooooooooooo.........',
    '......ooollllllllllllllooo......',
    '.....olllgggbggggggbggglllo.....',
    '.....ogaaaaaaaaaaaaaaaaaaao.....',
    '......oooooooooooooooooooo......',
    '......ogcoiswnnnnnnnniogco......',
    '......oagoisnnnnnnnnnioago......',
    '......olaoswnnnnnnnnniolao......',
    '......ogcosnnnnnnnnnniogco......',
    '......oagoorrnnnnnnbbooago......',
    '......olao.orrrrrrbbo.olao......',
    '......ogco..orrrrrbo..ogco......',
    '......oago...orrrro...oago......',
    '.....ollgco...orro...ollgco.....',
    '.....oggaco...orio...oggaco.....',
    '......oago...oirnio...oago......',
    '......olao.ooinrnnio..olao......',
    '......ogcoosinnrnnnio.ogco......',
    '......oagosinnnCrnnniooago......',
    '......olaoinnnCbbrnnniolao......',
    '......ogcoinnCrbbbrnniogco......',
    '......oagoiCCrrbbbbrrioago......',
    '......olaoCrrrrbbbbbbrolao......',
    '......oooooooooooooooooooo......',
    '.....ollllllbllllllbllllllo.....',
    '.....ogaaaaaaaaaaaaaaaaaaao.....',
    '......ooolcccccccccccccooo......',
    '.........oooooooooooooo.........',
    '................................',
    '................................',
  ],
);

export const relicLocket = sprite(
  'relic_locket',
  {
    o: 'ink',
    g: 'gold',
    l: 'lemon',
    a: 'amber',
    w: 'white',
    c: 'copper',
    s: 'salmonPink',
    p: 'pinkLilac',
    C: 'crimson',
    e: 'cerise',
  },
  [
    '................................',
    '................................',
    '....o.......................o...',
    '...ogo.....................olo..',
    '....oloo.................ooao...',
    '.....oago...............olgo....',
    '......oolo.............oaoo.....',
    '........ogoo.........oolo.......',
    '.........olaoo.....oogao........',
    '..........oogloooooaloo.........',
    '............ooagglgoo...........',
    '.............oggago.............',
    '..........oooooggooooo..........',
    '.........ollllooooggggo.........',
    '........ollllllooggggggo........',
    '.......olllwaallggaaggggo.......',
    '......olllwaallaaaagggggco......',
    '......olllaalllgggggglgcco......',
    '......olllallagssggaglccco......',
    '......olllagagspsCggalccco......',
    '.......olllgggeeeCgllccco.......',
    '........olgggggCCgllccco........',
    '.........ogggggggllccco.........',
    '..........ogggagllacco..........',
    '...........oggglaccco...........',
    '............oggcccco............',
    '.............occcco.............',
    '..............occo..............',
    '...............oo...............',
    '................................',
    '................................',
    '................................',
  ],
);

export const relicSaintKnuckle = sprite(
  'relic_saintknuckle',
  {
    o: 'ink',
    w: 'white',
    g: 'gold',
    l: 'lemon',
    a: 'amber',
    s: 'sky',
    c: 'cream',
    S: 'sand',
    C: 'copper',
    b: 'blue',
    f: 'flesh',
    e: 'cerise',
  },
  [
    '................................',
    '................................',
    '...............oo...............',
    '.............oowwoo.............',
    '...........oowwggwwoo...........',
    '..........ogoooooooogo..........',
    '.....o....ooolllllgooo....o.....',
    '....olooooolllaaaaggaooooolo....',
    '.....olllollawwwsssagaolllo.....',
    '......ollolawwwssssslaollo......',
    '.......oolooowsssssoooaoo.......',
    '........oowwwossssowwwoo........',
    '.....ooogowcSoooooowcSoCooo.....',
    '....oggoglowcwwwwwwcSoCCoggo....',
    '.....ooogowccSSSSSSccwoCooo.....',
    '........oowSSoooooowSSoo........',
    '.......oogooossbbbboooCoo.......',
    '......olloalssbbbbbblCollo......',
    '.....ollloaalbbbbbblCColllo.....',
    '....oloooooCCCllllCCCooooolo....',
    '.....o.....ooCCooCCoo.....o.....',
    '.............oolloo.............',
    '.............olgglo.............',
    '.............olggao.............',
    '............ooolaoo.............',
    '...........olllggllo............',
    '...........olgggggglo...........',
    '..........olgggfeggglo..........',
    '.........olaaaaaaaaaalo.........',
    '..........oooooooooooo..........',
    '................................',
    '................................',
  ],
);

export const relicJarOfTeeth = sprite(
  'relic_jarofteeth',
  {
    o: 'ink',
    c: 'coral',
    m: 'maroon',
    b: 'blood',
    r: 'red',
    n: 'night',
    d: 'dusk',
    s: 'sky',
    l: 'lilacGrey',
    w: 'white',
    C: 'cream',
    S: 'sand',
    W: 'wine',
    R: 'rose',
    L: 'lemon',
    g: 'gold',
    a: 'amber',
  },
  [
    '................................',
    '................................',
    '......oooooooooooooooooooo......',
    '.....occcccccccccccccccccmo.....',
    '....obcbrbrbrbrbrbrbrbrbrbmo....',
    '....obcbrbrbrbrbrbrbrbrbrbmo....',
    '....obcbrbrbrbrbrbrbrbrbrbmo....',
    '....obrbrbrbrbrbrbrbrbrbrbmo....',
    '....ommmmmmmmmmmmmmmmmmmmmmo....',
    '....oooooooooooooooooooooooo....',
    '....onnnnnnnnnnnnnnnnnnnnndo....',
    '....onnsnnnnnnnnnnnnnnnnlndo....',
    '....onnsnnnowonoConoSooolndo....',
    '....oWWWWWowCSooCSoCSowCoWmo....',
    '....oWRWWWoCCSoowCCCSowCoWmo....',
    '....oWRooWoCSoWoCCCCSoCSoWmo....',
    '....oWRwCoooooooCCSSoooooWmo....',
    '....oWRwCowwCCSoooooLLggaomo....',
    '....oWRCSowCCCSoowooLgggaomo....',
    '....oWoCSoCCSSSowCSoggaaaomo....',
    '....oWWoSoCSoCSoCCSogaogaomo....',
    '....oWWoooCoWooooooogooooomo....',
    '....oWoCoWoSowwCCSoWoowwCCmo....',
    '....oWoCSoCSowCCCSooSowCCCmo....',
    '....oWowCCCSoCCSSSowCoCCSSmo....',
    '....oWoCCCCSoCboCbowCoCSoCmo....',
    '....omoCCSSSoboWoboCSoCoWomo....',
    '.....omoooooWoWWWooCSooWWmo.....',
    '......ommmmmmmmmmmmmmmmmmo......',
    '.......oooooooooooooooooo.......',
    '................................',
    '................................',
  ],
);

export const relicSpareRack = sprite(
  'relic_sparerack',
  {
    o: 'ink',
    l: 'lemon',
    a: 'amber',
    g: 'gold',
    c: 'copper',
    b: 'brick',
    A: 'aubergine',
    w: 'wine',
    m: 'maroon',
    C: 'crimson',
    r: 'cream',
    B: 'brass',
    n: 'bronze',
    L: 'lilacGrey',
    e: 'cerise',
    v: 'clover',
    f: 'forest',
  },
  [
    '................................',
    '................................',
    '..............oooo..............',
    '.............olllao.............',
    '..........ooooggacoooo..........',
    '........ooccccoccoccccoo........',
    '......ooccbbbbboobbbbbccoo......',
    '.....occbbbbAAAAAAAAbbbbcco.....',
    '.....ocbbAAAAwwwwwwwwAAbbmo.....',
    '....ocbbAAwwwwCCCCCCCCwwbbco....',
    '....ocbAAwwCCCCCCCCCCCCCCbmo....',
    '....ocbbwwCCCCCCCCCCCCCCbbmo....',
    '....ocbbACrBCCCCrBCCCCrBbbmo....',
    '....ocbbAwCBACCCCBACCCCBAbmo....',
    '....ocbbAwCBACCCCBACCCCBAbmo....',
    '....ocbbAnCBACCnCBACCnCBAbmo....',
    '....ocbbAwBnACCCBnACCCBnAbmo....',
    '....ocbbAwCACCCCLACCCCCAbbmo....',
    '....ocbbAeeeCCCoooCCCeeebbmo....',
    '....ocbbewCCeCoBBnoCeCCCebmo....',
    '....ocbbewCCeoBBvnboeCCCebmo....',
    '....ocbbAeeeConnfvboCeeebbmo....',
    '....ocbbAwCCCCocbboCCCCCbbmo....',
    '....ocbbAwCCCCCoooCCCCCCbbmo....',
    '...oooooooooooooooooooooooooo...',
    '..occcccccccccccccccccccccccmo..',
    '..obbbbbbbbbbbbbbbbbbbbbbbbbmo..',
    '...ommmmmmmmmmmmmmmmmmmmmmmmo...',
    '....oooooooooooooooooooooooo....',
    '................................',
    '................................',
    '................................',
  ],
);

export const relicFirstCoin = sprite(
  'relic_firstcoin',
  { o: 'ink', g: 'gold', l: 'lemon', a: 'amber', w: 'white', c: 'copper', m: 'maroon', C: 'cream' },
  [
    '................................',
    '................................',
    '................................',
    '..........gl.........g..........',
    '...........l....aaaal...........',
    '..........a..oooooo.............',
    '........aa.oollllllo............',
    '........aoollllaalllo...........',
    '........olllaaallaalgo..........',
    '.......olllaalallalgggo.a.......',
    '...g...ollwlallllllggggo.a..g...',
    '....l.ollallllllllgaggggo..l....',
    '.....aollallllllllgggggaao......',
    '.....aollaalllccccgggaglaao.....',
    '.....aolallccccccccccggalao.....',
    '.....aolalcccawawawcccgalao.....',
    '......olalcawawawawawcaalao.a...',
    '......olallmmmmmmmmmmllalao.a...',
    '......olaglCcCcCcCcCclalaaoa....',
    '......olaglllCcCcCclllllao.a....',
    '....l.olgggllllllllllllaao.ll...',
    '...g.aogggggggllllaallaao...g...',
    '.....a.oggggggaaaaallaao........',
    '......a.oggglllllllaaao.........',
    '......a..oggaaaaaaaaao.a........',
    '..........oooooooooooaa.........',
    '............aa..................',
    '...........l..aa....l...........',
    '..........g..........g..........',
    '................................',
    '................................',
    '................................',
  ],
);

export const RELIC_SPRITES: SpriteDef[] = [
  relicGlassEye,
  relicMolar,
  relicBrassKnuckles,
  relicOiledGears,
  relicBoneDice,
  relicWeightedCoin,
  relicPocketSun,
  relicRatCrown,
  relicChalice,
  relicReceiptRoll,
  relicLedger,
  relicEternalFruit,
  relicBentSpoke,
  relicPinballHeart,
  relicCrackedHalo,
  relicSecondStomach,
  relicSilverFork,
  relicCrowsNest,
  relicDeed,
  relicHourglass,
  relicLocket,
  relicSaintKnuckle,
  relicJarOfTeeth,
  relicSpareRack,
  relicFirstCoin,
];
